export default __webpack_public_path__ + "static/media/workouts@3x.0600ac76.png";